/**
 * Definition for View Random
 * @module views/ViewRandom
 */
import * as THREE from 'three';
import config from '../config';
import { itemFaceCamera } from './Behaviours';

export default {

    /**
     * URI used in URL
     * @type String
     */
    path: '/',
    /**
     * is this views cameraIndex limited 0-1?
     * @type boolean
     */
    isFinite: false,
    /**
     * the desiredCameraIndex on view load
     * @type float
     */
    lastUpdate: 0,
    startCameraNormal: 0,
    lastCameraNormal: 0,

    gridIndex: [],
    gridpadding: config.views.random.gridpadding,
    gridsize: null,
    gridsize2: null,

    cameraPush: new THREE.Vector3(),

    /**
     * @type function
     */
    willMount() {
    },
    /**
     * @param items {Array} Array of Items
     */
    willUnmount(items) {
    },

    /**
     * @param cam {Cam} The Camera Wrapper
     * @param items {Array} Array of Items
     */
    update(cam, items) {

        items.forEach((item, i) => {

            if(!item.element) return;

            //camera alignment
            itemFaceCamera.call(item);

            //collision / bounce back
            const distance = item.currentPosition.clone();
            distance.sub(cam.cameraWrap.position);
            if(distance.length() < item.size/3) {
                this.cameraPush = distance.clone();
                this.cameraPush.multiplyScalar(-0.025);
                cam.cancelDesiredNormal();
            }
        });

        //rearrange items every 250ms 
        const now = new Date().getTime();
        if(now - this.lastUpdate > 250) {
            this.rearrangeItems(cam, items);
            this.lastUpdate = now;
        }
    },

    /**
     * @param cam {Cam} The Camera Wrapper
     * @param isInitial {boolean} true if items should be placed instantly
     */
    arrangeItems(items, isInitial) {

        this.gridIndex = [];
        this.gridsize = Math.floor(Math.sqrt(items.length));
        this.gridsize2 = Math.floor(this.gridsize/2);

        items.sort(() => Math.random() > 0.5? 1 : -1);

        items.forEach((item, i) => {
        
            let x = (i%this.gridsize);
            let z = Math.floor(i/this.gridsize)

            x -= this.gridsize2;
            z -= this.gridsize2;

            if(!this.gridIndex[x]) this.gridIndex[x] = [];
            this.gridIndex[x][z] = true;

            item.desiredPosition = new THREE.Vector3(x*this.gridpadding, 0, z*this.gridpadding);

            if(isInitial) {
                item.currentPosition = item.desiredPosition;
            }
        });
    },

    rearrangeItems(cam, items) {
        items.forEach((item, i) => {

            const oldItemX = item.desiredPosition.x/this.gridpadding;    
            const oldItemZ = item.desiredPosition.z/this.gridpadding;
            let newItemX = oldItemX;
            let newItemZ = oldItemZ;
            
            let needsUpdate = false;
            let direction = [0, 0];
            
            const distanceX = Math.round(cam.cameraWrap.position.x/this.gridpadding) - oldItemX;
            const distanceZ = Math.round(cam.cameraWrap.position.z/this.gridpadding) - oldItemZ;
            
            if(Math.abs(distanceX) > this.gridsize2) {
                needsUpdate = true;
                if(distanceX < 0) {
                    newItemX = oldItemX + distanceX - this.gridsize2;
                    direction = [1, 0];
                } else {
                    newItemX = oldItemX + distanceX + this.gridsize2;
                    direction = [-1, 0];
                }
            }
            if(Math.abs(distanceZ) > this.gridsize2) {
                needsUpdate = true;
                if(distanceZ < 0) {
                    newItemZ = oldItemZ + distanceZ - this.gridsize2;
                    direction = [0, 1];
                } else {
                    newItemZ = oldItemZ + distanceZ + this.gridsize2;
                    direction = [0, -1];
                }
            }

            if(needsUpdate) {
      
                this.gridIndex[oldItemX][oldItemZ] = false;
                if(!this.gridIndex[newItemX]) this.gridIndex[newItemX] = [];
                
                while(this.gridIndex[newItemX] && this.gridIndex[newItemX][newItemZ]) {
                  
                  newItemX += direction[0];
                  newItemZ += direction[1];
                  
                  if(!this.gridIndex[newItemX]) this.gridIndex[newItemX] = [];
                }

                this.gridIndex[newItemX][newItemZ] = true;
                
                item.element.material.opacity = 0;
                item.desiredPosition.x = newItemX*this.gridpadding;
                item.desiredPosition.z = newItemZ*this.gridpadding;
                item.currentPosition.copy(item.desiredPosition);
                item.currentRotation.copy(cam.cameraWrap.quaternion);
            }


        });
    },

    /**
     * @param i {float} currentCameraIndex
     * @param cameraWrap {Object} [THREE.js CameraWrap]
     * @param camera {Object} [THREE.js Camera]
     */
    lerpCamera(i, cameraWrap, camera) {

        const direction = new THREE.Vector3();
        cameraWrap.getWorldDirection(direction);

        const dist = this.lastCameraNormal - i;

        direction.multiplyScalar(dist*25);
        direction.add(cameraWrap.position);

        direction.add(this.cameraPush);
        this.cameraPush.multiplyScalar(0.96);
        direction.y = 0;

        this.lastCameraNormal = i;
        return direction;
    }
}